export const LANDING = '/'
export const SIGN_UP = '/sign-up'
export const SIGN_IN = '/sign-in'
export const HOME = '/home'
export const ACCOUNT = '/account'
export const PASSWORD_FORGET = '/forgot-password'
export const ADMIN = '/admin'
export const ADMIN_DETAILS = '/admin/:id'
export const JOIN_NETWORK = '/join-network'
export const THANK_YOU = '/thank-you'
